/*eslint-disable*/ export const messages = JSON.parse("{\"select.label.optional\":[\"Valinnainen\"]}");
//# sourceMappingURL=messages.mjs.map